/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { ChangeEvent, FC } from 'react';
import { styled } from 'linaria/react';
import { Icon } from '@shared/ui/atoms';
import { checkboxMap } from '@shared/config/checkbox';
import { Variants, getIconColor } from '@shared/lib/utils/checkboxRadioBuilder';
import { CheckboxRadioBuilder } from '@shared/ui/atoms/Checkbox/CheckboxRadioBuilder';
export interface CheckboxProps extends React.HTMLAttributes<HTMLInputElement> {
  checked?: boolean;
  disabled?: boolean;
  hasError?: boolean;
  indeterminate?: boolean;
  size?: keyof typeof checkboxMap;
  name?: string;
  hint?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  variant?: Variants;
}
const Checkbox: FC<CheckboxProps> = ({
  disabled,
  hasError,
  checked,
  indeterminate,
  size,
  name,
  onChange,
  hint,
  children,
  variant,
  ...rest
}) => {
  const {
    IconCheck,
    indeterminateWidth
  } = checkboxMap[size as 'lg'];
  const checkboxWrapperProps = {
    disabled,
    hasError,
    checked,
    size,
    name,
    onChange,
    hint,
    children,
    variant,
    ...rest
  };
  const getIcon = () => indeterminate ?
  // @ts-ignore
  <Indeterminate checked={checked} variant={variant} length={indeterminateWidth} disabled={disabled} /> : <Icon icon={IconCheck} />;
  return (
    // @ts-ignore
    <CheckboxRadioBuilder {...checkboxWrapperProps} inputType="checkbox" checkIcon={getIcon()}>
      {children}
    </CheckboxRadioBuilder>
  );
};
const _exp = /*#__PURE__*/() => ({
  length
}) => length;
const _exp2 = /*#__PURE__*/() => ({
  variant
}) => getIconColor(variant)({});
const Indeterminate = /*#__PURE__*/styled('div')({
  name: "Indeterminate",
  class: "idkifgi",
  propsAsIs: false,
  vars: {
    "idkifgi-0": [_exp(), "px"],
    "idkifgi-1": [_exp2()]
  }
});
Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  hasError: false,
  indeterminate: false,
  children: null,
  size: 'md',
  name: '',
  hint: '',
  onChange: () => {},
  variant: 'default'
};
export default Checkbox;

require("./Checkbox.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Checkbox.tsx");